module.exports = __webpack_public_path__ + "static/media/icon-cat-ALL.4e72248c.svg";